
    <!--
 * 竖版-全局弹窗
 * @LastEditTime: Sat Feb 08 2025 17:56:13 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_KSMY32"  :class="[`normal`,`u_c_KSMY32`]" ><div id="u_c_ZRCG33"  v-show="pageData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup`,`u_c_ZRCG33`]" @click="u_c_ZRCG33_event_RK4620($event)"><div id="u_c_27K334"  :class="[`normal popup-content`,`u_c_27K334`]" @click="u_c_27K334_event_N70G19($event)"><div id="u_c_SZ0Y35"  :class="[`normal popup-title`,`u_c_SZ0Y35`]" >{{langData.bindPopupTitle}}</div><table id="u_c_KERW37"  :class="[`normal`,`u_c_KERW37`]" ><tbody id="u_c_QRKP38"  :class="[`normal`,`u_c_QRKP38`]" ><tr id="u_c_VFWQ39"  :class="[`normal`,`u_c_VFWQ39`]" ><td id="u_c_R05840"  :class="[`normal popup-txt`,`u_c_R05840`]" >{{`${ langData.serverTitle }`}}</td><td id="u_c_VD2242"  :class="[`normal role-select `,`u_c_VD2242`]" ><select id="u_c_Q3XA43"  v-model="compData.selectedServerSid" :class="[`normal select popup-txt`,`u_c_Q3XA43`]" ><option id="u_c_UMAB44" value="0" disabled="disabled" :class="[`normal`,`u_c_UMAB44`]" >{{`${ langData.pleaseSelectServer }：`}}</option><optgroup id="u_c_SFR546"  :label="`${ langData.roleServer }：`" :class="[`normal`,`u_c_SFR546`]" ><option id="u_c_RMZC47"  v-for="(sItem, sIndex) in pageData.hasRoleServerList" :key="sIndex" :value="sItem.sid" :class="[`normal`,`u_c_RMZC47`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_PJCF49"  :label="`${ langData.allServer }：`" :class="[`normal`,`u_c_PJCF49`]" ><option id="u_c_1Z6M50"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem.sid" :class="[`normal`,`u_c_1Z6M50`]" >{{`${ sItem.sname }`}}</option></optgroup></select></td></tr><tr id="u_c_UU6X52"  :class="[`normal`,`u_c_UU6X52`]" ><td id="u_c_YPOE53"  :class="[`normal popup-txt`,`u_c_YPOE53`]" >{{`${ langData.roleTitle }`}}</td><td id="u_c_28CT55"  :class="[`normal role-select`,`u_c_28CT55`]" ><select id="u_c_YPLL56"  v-model="compData.selectRoleIndex" :class="[`normal select popup-txt`,`u_c_YPLL56`]" ><option id="u_c_Y3O657"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal`,`u_c_Y3O657`]" >{{`${ rItem.roleName }`}}</option></select></td></tr></tbody></table><div id="u_c_PVL122"  v-if="pageData.isFacebookCollect" :class="[`normal popup-title`,`u_c_PVL122`]" >{{langData.fbBindOnce}}</div><a id="u_c_XS6A59" href="javascript:;" :class="[`normal popup-sure`,`u_c_XS6A59`]" @click="u_c_XS6A59_event_XONV17($event)">{{`${ langData.ensure }`}}</a><a id="u_c_W8QF61" href="javascript:;" :class="[`normal popup-close`,`u_c_W8QF61`]" @click="u_c_W8QF61_event_IU3V18($event)"></a></div></div><div id="u_c_SXG462"  v-show="pageData.previewPopup == 'tips' || pageData.commonTipState" :class="[`normal popup`,`u_c_SXG462`]" @click="u_c_SXG462_event_O6Z732($event)"><div id="u_c_UH2P63"  :class="[`normal popup-content`,`u_c_UH2P63`]" @click="u_c_UH2P63_event_HANU33($event)"><a id="u_c_WZMO64" href="javascript:;" :class="[`normal popup-close`,`u_c_WZMO64`]" @click="u_c_WZMO64_event_NV9T31($event)"></a><div id="u_c_3UFU65"  :class="[`normal popup-txt`,`u_c_3UFU65`]" >{{`${ pageData.commonTipsContent }`}}</div><a id="u_c_WD8J67" href="javascript:;" :class="[`normal popup-sure`,`u_c_WD8J67`]" @click="u_c_WD8J67_event_N0XR30($event)">{{`${ langData.ensure }`}}</a></div></div><div id="u_c_VWYS69"  v-show="pageData.previewPopup == 'bindSucc' || pageData.bindSuccState" :class="[`normal popup`,`u_c_VWYS69`]" @click="u_c_VWYS69_event_O6Z732($event)"><div id="u_c_RZZL70"  :class="[`normal popup-content`,`u_c_RZZL70`]" @click="u_c_RZZL70_event_HANU33($event)"><a id="u_c_PQ5W71" href="javascript:;" :class="[`normal popup-close`,`u_c_PQ5W71`]" @click="u_c_PQ5W71_event_NV9T31($event)"></a><div id="u_c_KGCF72"  :class="[`normal`,`u_c_KGCF72`]" ><div id="u_c_PN6X73"  :class="[`normal`,`u_c_PN6X73`]" ></div><div id="u_c_VT8074"  :class="[`normal popup-txt`,`u_c_VT8074`]" >{{`${ langData.submitSucc }`}}</div></div><a id="u_c_S7BT76" href="javascript:;" :class="[`normal popup-sure`,`u_c_S7BT76`]" @click="u_c_S7BT76_event_N0XR30($event)">{{`${ langData.ensure }`}}</a></div></div><div id="u_c_Q6MW78"  v-show="pageData.previewPopup == 'preview' || pageData.awardPopupState" :class="[`normal popup`,`u_c_Q6MW78`]" @click="u_c_Q6MW78_event_X03U21($event)"><div id="u_c_1YLM79"  :class="[`normal transparent-popup-content`,`u_c_1YLM79`]" @click="u_c_1YLM79_event_XWXX22($event)"><a id="u_c_RU5780" href="javascript:;" :class="[`normal transparent-popup-close`,`u_c_RU5780`]" @click="u_c_RU5780_event_55JO29($event)"></a><div id="u_c_LIUA81"  :class="[`normal popup-title`,`u_c_LIUA81`]" >{{langData.seeAward}}</div><div id="u_c_12T383"  v-html="pageData.awardPopupContent" :class="[`normal`,`u_c_12T383`]" ></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"selectRoleIndex":0,"showBindPopup":true,"showTipsPopup":false,"showSuccPopup":false,"showAwardPopup":false,"selectedServerSid":0},"zh-TW":{"selectRoleIndex":0,"showBindPopup":true,"showTipsPopup":false,"showSuccPopup":false,"showAwardPopup":false,"selectedServerSid":0}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "gm99"
    const router = Router();
    const route = useRoute();
    const compName = '全局弹窗';

    // 自定义setup - 开始
    const initRoleList = inject('initRoleList', () => {})

compData.showBindPopup = false
compData.showTipsPopup = false
compData.showSuccPopup = false
compData.showAwardPopup = false
compData.previewPopup = '';


// 监听：如果伺服器已默认选上，就更新弹窗里面的选中
// watch(
//   () => pageData.serverIndex,
//   (value) => {
//     if (value && value !== compData.selectServerIndex) {
//       compData.selectServerIndex = value
//     }
//   }
// )

watch(() => pageData.serverId, (value) => {
  if (value && value !== compData.selectedServerSid) {
    compData.selectedServerSid = value
  }
})



// 监听：选中伺服器厚，自动获取角色列表
// watch(
//   () => compData.selectServerIndex,
//   async (value) => {
//     if (value && compData.selectServerIndex !== pageData.serverIndex) {
//       let sid = pageData.serverList[value].sid
//       compData.selectRoleIndex = 0
//       let getRoleListRes = await initRoleList(sid)
//       if (getRoleListRes && pageData.roleList.length == 2) {
//         compData.selectRoleIndex = 1
//       }
//     }
//   }
// )

// 监听：选中伺服器厚，自动获取角色列表
watch(
  () => compData.selectedServerSid,
  async (value) => {
    if (value && compData.selectedServerSid !== pageData.serverId) {
      let sid = value;
      compData.selectRoleIndex = 0
      let getRoleListRes = await initRoleList(sid)
      if (getRoleListRes && pageData.roleList.length == 2) {
        compData.selectRoleIndex = 1
      }
    }
  }
)

// 监听：角色自动选上后，更新弹窗中的选中
watch(
  () => pageData.roleIndex,
  (value) => {
    if (value && value !== compData.selectRoleIndex) {
      compData.selectRoleIndex = value
    }
  }
);
      // 绑定弹窗的click事件
      const u_c_ZRCG33_event_RK4620= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_27K334_event_N70G19= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_XS6A59_event_XONV17= async (e)=>{
        try {if (~compData.selectRoleIndex && ~compData.selectedServerSid) {
  const serverItem = pageData.serverList.find(
    (item) => item.sid === compData.selectedServerSid
  )
  if (!serverItem) {
    return
  }
  pageData.serverId = serverItem.sid
  pageData.serverName = serverItem.sname
  pageData.sid = serverItem.id

  pageData.roleIndex = compData.selectRoleIndex
  pageData.roleId = pageData.roleList[compData.selectRoleIndex].roleID
  pageData.roleName =
    pageData.roleList[compData.selectRoleIndex].roleName
  // fb额外请求绑定接口
  if (pageData.isFacebookCollect) {
    let host =
      utils.getMainHost() == "gm99.com" ? "eventsapi" : "gactivityapi";
    let res = await request.getJSON(
      `https://${host}.${utils.getMainHost()}/activity/execute?name=${
              pageData.pageId
            }&action=bind`, {
        params: JSON.stringify({
          server_id: pageData.serverId,
          server_sid: pageData.sid,
          server_name: encodeURIComponent(pageData.serverName),
          role_id: pageData.roleId,
          role_name: encodeURIComponent(pageData.roleName),
        }),
      }
    );
    if (res.result != 1) {
      compData.inputCodeTip = getLangTxt(res.code, res.msg);
      compData.showInputCodeTip = true
      // pageData.commonTipState = true;
      // pageData.commonTipsContent = getLangTxt(res.code, res.msg);
    }
    if (res.result == 1) {
      pageData.facebookRoleId = res.data.bind_data?.role_id || "";
      pageData.facebookServerId = res.data.bind_data?.server_id || "";
      pageData.facebookServerName = res.data.bind_data?.server_name || "";
      pageData.facebookRoleName = res.data.bind_data?.role_name || "";
      pageData.facebookServerSid = res.data.bind_data?.server_sid || "";
      // 重新请求一次basic获取fb_deep_link
      const res_basic = await request.getJSON(
        `https://${host}.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=basic`, {
          params: JSON.stringify({
            language: curLang,
          }),
        })
      pageData.facebookDeepLink = res_basic?.data?.facebook_deep_link || "";
      pageData.facebookBindStatus = !!res_basic?.data?.facebook_bind_status;
    }
  }
}
pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_W8QF61_event_IU3V18= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 通用提示弹窗的click事件
      const u_c_SXG462_event_O6Z732= async (e)=>{
        try {pageData.commonTipState = false;} catch (error) {console.log(error)}
      };
      // 通用-弹窗内容的click事件
      const u_c_UH2P63_event_HANU33= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 通用-关闭的click事件
      const u_c_WZMO64_event_NV9T31= async (e)=>{
        try {pageData.commonTipState = false;} catch (error) {console.log(error)}
      };
      // 通用-确定的click事件
      const u_c_WD8J67_event_N0XR30= async (e)=>{
        try {pageData.commonTipState = false;} catch (error) {console.log(error)}
      };
      // 绑定成功弹窗的click事件
      const u_c_VWYS69_event_O6Z732= async (e)=>{
        try {pageData.bindSuccState = false;} catch (error) {console.log(error)}
      };
      // 绑定成功-弹窗内容的click事件
      const u_c_RZZL70_event_HANU33= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 绑定成功-关闭的click事件
      const u_c_PQ5W71_event_NV9T31= async (e)=>{
        try {pageData.bindSuccState = false;} catch (error) {console.log(error)}
      };
      // 绑定成功-确定的click事件
      const u_c_S7BT76_event_N0XR30= async (e)=>{
        try {pageData.bindSuccState = false;} catch (error) {console.log(error)}
      };
      // 奖励详情弹窗的click事件
      const u_c_Q6MW78_event_X03U21= async (e)=>{
        try {pageData.awardPopupState = false} catch (error) {console.log(error)}
      };
      // 奖励详情弹窗-弹窗内容的click事件
      const u_c_1YLM79_event_XWXX22= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 通用-关闭的click事件
      const u_c_RU5780_event_55JO29= async (e)=>{
        try {pageData.awardPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_KSMY32.normal{
position:relative;

}
}.default{
.u_c_27K334.normal{
position:relative;

}
}.default{
.u_c_SZ0Y35.normal{
position:relative;
margin-top:0.84rem;

}
}.default{
.u_c_KERW37.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
border-spacing:0.27rem 0.40rem;

}

.u_c_KERW37.normal select{
background:none;
border:none;
outline:none;
appearance:none;

}

.u_c_KERW37.normal .select{
width:6.87rem;
height:1.07rem;
padding-left:0.40rem;

}
}.default{
.u_c_QRKP38.normal{
position:relative;

}
}.default{
.u_c_VFWQ39.normal{
position:relative;

}
}.default{
.u_c_R05840.normal{
position:relative;
text-align:center;

}
}.default{
.u_c_VD2242.normal{
position:relative;

}
}.default{
.u_c_Q3XA43.normal{
position:relative;
color:#333 !important;

}
}.default{
.u_c_UMAB44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_SFR546.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_RMZC47.normal{
position:relative;

}
}.default{
.u_c_PJCF49.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_1Z6M50.normal{
position:relative;

}
}.default{
.u_c_UU6X52.normal{
position:relative;

}
}.default{
.u_c_YPOE53.normal{
position:relative;

}
}.default{
.u_c_28CT55.normal{
position:relative;

}
}.default{
.u_c_YPLL56.normal{
position:relative;
color:#333 !important;

}
}.default{
.u_c_Y3O657.normal{
position:relative;

}
}.default{
.u_c_XS6A59.normal{
position:absolute;
bottom:1.56rem;
left:50%;
transform:translateX(-50%);

}
}.default{
.u_c_W8QF61.normal{
position:absolute;
top:0.19rem;
right:0.27rem;

}
}.default{
.u_c_SXG462.normal{
z-index:20;

}
}.default{
.u_c_UH2P63.normal{
position:relative;

}
}.default{
.u_c_WZMO64.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.default{
.u_c_3UFU65.normal{
position:relative;
width:100%;
padding:0 0.40rem;
text-align:center;
box-sizing:border-box;
margin-top:2.27rem;
line-height:150%;

}
}.default{
.u_c_WD8J67.normal{
position:absolute;
bottom:1.07rem;
left:50%;
transform:translateX(-50%);

}
}.default{
.u_c_RZZL70.normal{
position:relative;

}
}.default{
.u_c_PQ5W71.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.default{
.u_c_KGCF72.normal{
position:relative;
box-sizing:border-box;
margin-top:2.19rem;

}
}.default{
.u_c_PN6X73.normal{
position:relative;
width:1.68rem;
height:1.45rem;
background:no-repeat center;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16605377916465.png);
background-size:contain;
display:block;
margin:auto;

}
}.default{
.u_c_VT8074.normal{
position:relative;
box-sizing:border-box;
text-align:center;
padding:0 0.40rem;
margin-top:0.28rem;

}
}.default{
.u_c_S7BT76.normal{
position:absolute;
bottom:1.07rem;
left:50%;
transform:translateX(-50%);

}
}.default{
.u_c_Q6MW78.normal{
position:relative;

}
}.default{
.u_c_1YLM79.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_RU5780.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.default{
.u_c_LIUA81.normal{
position:relative;
margin-top:40%;

}
}.default{
.u_c_12T383.normal{
position:relative;
box-sizing:border-box;
margin:auto;
margin-top:0.35rem;
width:90%;
height:60%;
overflow:auto;
text-align:center;
white-space:pre-wrap;
color:#ffffff;

}
}.zh-TW{
.u_c_KSMY32.normal{
position:relative;

}
}.zh-TW{
.u_c_27K334.normal{
position:relative;

}
}.zh-TW{
.u_c_SZ0Y35.normal{
position:relative;
margin-top:0.84rem;

}
}.zh-TW{
.u_c_KERW37.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
border-spacing:0.27rem 0.40rem;

}

.u_c_KERW37.normal select{
background:none;
border:none;
outline:none;
appearance:none;

}

.u_c_KERW37.normal .select{
width:6.87rem;
height:1.07rem;
padding-left:0.40rem;

}
}.zh-TW{
.u_c_QRKP38.normal{
position:relative;

}
}.zh-TW{
.u_c_VFWQ39.normal{
position:relative;

}
}.zh-TW{
.u_c_R05840.normal{
position:relative;
text-align:center;

}
}.zh-TW{
.u_c_VD2242.normal{
position:relative;

}
}.zh-TW{
.u_c_Q3XA43.normal{
position:relative;
color:#333 !important;

}
}.zh-TW{
.u_c_UMAB44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_SFR546.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_RMZC47.normal{
position:relative;

}
}.zh-TW{
.u_c_PJCF49.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_1Z6M50.normal{
position:relative;

}
}.zh-TW{
.u_c_UU6X52.normal{
position:relative;

}
}.zh-TW{
.u_c_YPOE53.normal{
position:relative;

}
}.zh-TW{
.u_c_28CT55.normal{
position:relative;

}
}.zh-TW{
.u_c_YPLL56.normal{
position:relative;
color:#333 !important;

}
}.zh-TW{
.u_c_Y3O657.normal{
position:relative;

}
}.zh-TW{
.u_c_XS6A59.normal{
position:absolute;
bottom:1.56rem;
left:50%;
transform:translateX(-50%);

}
}.zh-TW{
.u_c_W8QF61.normal{
position:absolute;
top:0.19rem;
right:0.27rem;

}
}.zh-TW{
.u_c_SXG462.normal{
z-index:20;

}
}.zh-TW{
.u_c_UH2P63.normal{
position:relative;

}
}.zh-TW{
.u_c_WZMO64.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.zh-TW{
.u_c_3UFU65.normal{
position:relative;
width:100%;
padding:0 0.40rem;
text-align:center;
box-sizing:border-box;
margin-top:2.27rem;
line-height:150%;

}
}.zh-TW{
.u_c_WD8J67.normal{
position:absolute;
bottom:1.07rem;
left:50%;
transform:translateX(-50%);

}
}.zh-TW{
.u_c_RZZL70.normal{
position:relative;

}
}.zh-TW{
.u_c_PQ5W71.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.zh-TW{
.u_c_KGCF72.normal{
position:relative;
box-sizing:border-box;
margin-top:2.19rem;

}
}.zh-TW{
.u_c_PN6X73.normal{
position:relative;
width:1.68rem;
height:1.45rem;
background:no-repeat center;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16605377916465.png);
background-size:contain;
display:block;
margin:auto;

}
}.zh-TW{
.u_c_VT8074.normal{
position:relative;
box-sizing:border-box;
text-align:center;
padding:0 0.40rem;
margin-top:0.28rem;

}
}.zh-TW{
.u_c_S7BT76.normal{
position:absolute;
bottom:1.07rem;
left:50%;
transform:translateX(-50%);

}
}.zh-TW{
.u_c_Q6MW78.normal{
position:relative;

}
}.zh-TW{
.u_c_1YLM79.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_RU5780.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.zh-TW{
.u_c_LIUA81.normal{
position:relative;
margin-top:40%;

}
}.zh-TW{
.u_c_12T383.normal{
position:relative;
box-sizing:border-box;
margin:auto;
margin-top:0.35rem;
width:90%;
height:60%;
overflow:auto;
text-align:center;
white-space:pre-wrap;
color:#ffffff;

}
}
</style>
